<template>
  <div>
    <ul class="list-resource">
      <li v-for="(resource, key) in resources" :key="key">
        <v-text-field @input="setValue" :label="resource.name" v-model="resource['uniq']"></v-text-field>
      </li>
    </ul>

  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ['values','value'],
  data: () => ({

  }),
  created() {
       for(let i=0;i<this.resources.length;i++){
          this.resources[i]['uniq'] = '';
              if(this.value  && this.value.length){
                for(let j=0;j<this.value.length;j++){
                  if(this.value[j]['id'] == this.resources[i]['id']){
                         this.resources[i]['uniq'] = this.value[j]['uniq'] ? this.value[j]['uniq'] : this.value[j]['pivot']['uniq'];
                  }
                }
            }
        }

  },
  methods: {

  },
  computed: {
    ...mapState(["resources"]),
  },
  methods:{
    setValue(){
     
      this.$emit('input',this.resources);
    }
  }
};
</script>

<style lang="scss">
.list-resource {
  padding:17px;
  list-style: none;
}
</style>
